import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<RootState, KwikspaceStoreState>(
  featureKey
);

export const getPurchasePriceList = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.purchases
);

export const getPurchasePriceListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.purchasesLoading
);

export const getPurchasePriceListError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.purchasesError
);

export const getPurchaseSizes = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.purchaseSizes
);

export const getPurchaseSizesLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.purchaseSizesLoading
);

export const getPurchaseSizesError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.purchaseSizesError
);

export const getDrawingLayoutDetails = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.drawingLayoutDetail
);

export const getDrawingLayoutDetailsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.drawingLayoutDetailLoading
);

export const getDrawingLayoutDetailsError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.drawingLayoutDetailError
)

export const getMatchedPricing = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.matchedPricing
);

export const getMatchedPricingLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.matchedPricingLoading
);

export const getMatchedPricingError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.matchedPricingError
);

export const getCreatedPurchaseLineItems = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createdPurchaseLineItems
);

export const getCreatedPurchaseLineItemsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createPurchaseLineItemLoading
);

export const getCreatedPurchaseLineItemsError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createPurchaseLineItemError
);

export const getCreatedLineItemsSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createPurchaseLineItemSuccess
);

export const getCreatedLineItemConfigs = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createdPurchaseLineItemConfigs
);

export const getCreatedLineItemConfigsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createPurchaseLineItemConfigLoading
);

export const getCreatedLineItemConfigsError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createPurchaseLineItemConfigError
);

export const getCreatedLineItemConfigsSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.createPurchaseLineItemConfigSuccess
);

export const getFpProjectCategoryList = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectCategories
);

export const getFpProjectCategoryListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectCategoriesLoading
);

export const getFpProjectCategoryError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectCategoriesError
);

export const getFpProjectSubCategoryList = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectSubCategories
);

export const getFpProjectSubCategoryListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectSubCategoriesLoading
);

export const getFpProjectSubCategoryListError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectSubCategoriesError
);

export const getFpProjectSizeList = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectSizes
);

export const getFpProjectSizeListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectSizesLoading
);

export const getFpProjectSizeListError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectSizesError
);

export const getFpProjectExtrasList = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectExtras
);

export const getFpProjectExtrasListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectExtrasLoading
);

export const getFpProjectExtrasListError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectExtrasError
);

export const getFpProjectCategorySize = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectCategorySize
);

export const getFpProjectCategorySizeLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectCategorySizeLoading
);

export const getFpProjectCategorySizeError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectCategorySizeError
);

export const getFpProjectList = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectList
);

export const getFpProjectListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectListLoading
);

export const getFpProjectListError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectListError
);

export const getFpProjectPriceList = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectPriceList
);

export const getFpProjectPriceListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectPriceListLoading
);

export const getFpProjectPriceListError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.fpProjectPriceListError
);

export const updatePurchaseLineItemSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.updatePurchaseLineItemSuccess
);

export const updatePurchaseLineItemLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.updatePurchaseLineItemLoading
);

export const updatePurchaseLineItemError = createSelector(
  getKwikspaceAppState,
  (state) => state.purchase.updatePurchaseLineItemError
);
